import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { ADDED_BY_ID } from "../../../Constants";
import { loadBinLevelDropdownData, loadBranchDropdownData, loadSlocDropdownData, loadStorageTypeDropdownData, loadUomDropdownData, loadWeigheUomDropdownData, loadZoneMasterParentCodeDropdownData, postBinMasterDatas } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import * as HeaderAuthentication from '../../HeaderAuthentication'

const statusOptions = [
    { value: 101, label: "Active" },
    { value: 102, label: "Inactive" }
]

const AddBinMaster = (props) => {

    let dispatch = useDispatch();
    const { getParentCodeDropdownData, weightUomDropdownData, slocDropdown, branchDropdown, uomDropdownData, storageTypeDropdown, binLevelDropdown } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    const binID = props.binID;
    const getSinleBinMasterData = props.getSinleBinMasterData;
    const binMasterData = props.binMasterData;

    const [binData, setBinData] = useState({
        BinCode: "",
        BarCodeID: "",
        Length: null,
        Width: null,
        Height: null,
        Volume: null,
        Dimension: "",
        UOMID: null,
        Branch_ID: null,
        Sloc_ID: null,
        Zone_ID: null,
        StorageTypeID: null,
        BinLevelID: null,
        RackCode: "",
        RackLane: "",
        Sequence: null,
        Weight: null,
        WeightUOMID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
        StatusID: null
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadBranchDropdownData());
        dispatch(loadUomDropdownData());
        dispatch(loadWeigheUomDropdownData());
        dispatch(loadStorageTypeDropdownData());
        dispatch(loadBinLevelDropdownData());
    }, []);

    useEffect(() => {
        if (binID && getSinleBinMasterData?.length > 0) {
            const BinData = getSinleBinMasterData[0];
            setBinData({
                Bin_IDPK: binID,
                BinCode: BinData.BinCode || "",
                BarCodeID: BinData.BarCodeID || "",
                Length: BinData.Length || "",
                Width: BinData.Width || "",
                Height: BinData.Height || "",
                Volume: BinData.Volume || "",
                Dimension: BinData.Dimension || "",
                UOMID: { value: BinData.UOMID, label: BinData.UOMCode },
                Branch_ID: { value: BinData.Plant_ID, label: BinData.PlantName },
                Sloc_ID: { value: BinData.Sloc_ID, label: BinData.SlocName },
                Zone_ID: { value: BinData.Zone_ID, label: BinData.ZoneName },
                StorageTypeID: { value: BinData.StorageTypeID, label: BinData.StorageTypeCode },
                BinLevelID: { value: BinData.BinLevelID, label: `${BinData.BinLevelCode} - ${BinData.BinLevel}` },
                RackCode: BinData.RackCode || "",
                RackLane: BinData.RackLane || "",
                Sequence: BinData.Sequence || "",
                Weight: BinData.Weight || "",
                WeightUOMID: { value: BinData.WeightUOMID, label: BinData.WeightUOM },
                StatusID: { value: BinData.StatusID, label: BinData.Status },
                CompanyID: BinData.CompanyID,
                AddedByID: ADDED_BY_ID
            });
        }
    }, [binID, getSinleBinMasterData]);

    const handleChange = (field, value) => {
        let updatedData = { ...binData, [field]: value };

        // Auto-calculate Volume if Length, Width, or Height is updated
        if (['Length', 'Width', 'Height'].includes(field)) {
            const length = parseFloat(field === 'Length' ? value : binData.Length);
            const width = parseFloat(field === 'Width' ? value : binData.Width);
            const height = parseFloat(field === 'Height' ? value : binData.Height);

            if (!isNaN(length) && !isNaN(width) && !isNaN(height)) {
                updatedData.Volume = length * width * height;
            } else {
                updatedData.Volume = "";
            }
        }

        // Clear Sloc and Zone when Plant changes
        if (field === 'Branch_ID') {
            updatedData.Sloc_ID = null;
            updatedData.Zone_ID = null;
            dispatch(loadSlocDropdownData([value?.value]));
        }

        // Clear Zone when Sloc changes
        if (field === 'Sloc_ID') {
            updatedData.Zone_ID = null;
            dispatch(loadZoneMasterParentCodeDropdownData(value?.value));
        }

        setBinData(updatedData);

        if (errors[field]) {
            setErrors(prevErrors => ({ ...prevErrors, [field]: value ? "" : `required !` }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        ['BinCode', 'BarCodeID', 'Length', 'Width', 'Height', 'Volume', 'Dimension', 'UOMID', 'Branch_ID', 'Sloc_ID', 'Zone_ID', 'StorageTypeID', 'BinLevelID', 'RackCode', 'RackLane', 'Sequence', 'Weight', 'WeightUOMID',].forEach(field => {
            if (!binData[field]) newErrors[field] = `required !`;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddBinMasterData = (e) => {
        e.preventDefault(); // Prevent default form submission behavior

        if (validateForm()) { // Run validation check
            const formData = {
                ...binData,
                UOMID: binData.UOMID?.value,
                Branch_ID: binData.Branch_ID?.value,
                Sloc_ID: binData.Sloc_ID?.value,
                Zone_ID: binData.Zone_ID?.value,
                StorageTypeID: binData.StorageTypeID?.value,
                BinLevelID: binData.BinLevelID?.value,
                WeightUOMID: binData.WeightUOMID?.value,
                StatusID: binData.StatusID?.value
            };
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(formData),
            };

            // Dispatch the Redux action to post data
            dispatch(postBinMasterDatas(requestOption, props.handleCloseModal, binID, binMasterData));

            console.log(formData, 'formData'); // Debug log
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{binID ? "Edit Bin Master" : "Add Bin Master"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Bin Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.BinCode}
                                            onChange={(e) => handleChange('BinCode', e.target.value)}
                                        />
                                    </div>
                                    {errors.BinCode && <div className="text-danger">{errors.BinCode}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Bar Code ID <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.BarCodeID}
                                            onChange={(e) => handleChange('BarCodeID', e.target.value)}
                                        />
                                    </div>
                                    {errors.BarCodeID && <div className="text-danger">{errors.BarCodeID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Length<span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Length}
                                            onChange={(e) => handleChange('Length', e.target.value)}
                                        />
                                    </div>
                                    {errors.Length && <div className="text-danger">{errors.Length}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Width <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Width}
                                            onChange={(e) => handleChange('Width', e.target.value)}
                                        />
                                    </div>
                                    {errors.Width && <div className="text-danger">{errors.Width}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Height <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Height}
                                            onChange={(e) => handleChange('Height', e.target.value)}
                                        />
                                    </div>
                                    {errors.Height && <div className="text-danger">{errors.Height}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Volume <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Volume}
                                            readOnly
                                        />
                                    </div>
                                    {errors.Volume && <div className="text-danger">{errors.Volume}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Dimension <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Dimension}
                                            onChange={(e) => handleChange('Dimension', e.target.value)}
                                        />
                                    </div>
                                    {errors.Dimension && <div className="text-danger">{errors.Dimension}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Unit <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={uomDropdownData}
                                            placeholder="Select"
                                            value={binData.UOMID}
                                            onChange={(value) => handleChange('UOMID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.UOMID && <div className="text-danger">{errors.UOMID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Plant <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={branchDropdown}
                                            placeholder="Select"
                                            value={binData.Branch_ID}
                                            onChange={(value) => handleChange('Branch_ID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.Branch_ID && <div className="text-danger">{errors.Branch_ID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Sloc <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={slocDropdown}
                                            placeholder="Select"
                                            value={binData.Sloc_ID}
                                            onChange={(value) => handleChange('Sloc_ID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            isDisabled={!binData.Branch_ID} // Disable unless a Plant is selected
                                        />
                                    </div>
                                    {errors.Sloc_ID && <div className="text-danger">{errors.Sloc_ID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Zone Name <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={getParentCodeDropdownData}
                                            placeholder="Select"
                                            value={binData.Zone_ID}
                                            onChange={(value) => handleChange('Zone_ID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            isDisabled={!binData.Sloc_ID}
                                        />
                                    </div>
                                    {errors.Zone_ID && <div className="text-danger">{errors.Zone_ID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Storage Type Code <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={storageTypeDropdown}
                                            placeholder="Select"
                                            value={binData.StorageTypeID}
                                            onChange={(value) => handleChange('StorageTypeID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.StorageTypeID && <div className="text-danger">{errors.StorageTypeID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Level <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={binLevelDropdown}
                                            placeholder="Select"
                                            value={binData.BinLevelID}
                                            onChange={(value) => handleChange('BinLevelID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.BinLevelID && <div className="text-danger">{errors.BinLevelID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Rack Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.RackCode}
                                            onChange={(e) => handleChange('RackCode', e.target.value)}
                                        />
                                    </div>
                                    {errors.RackCode && <div className="text-danger">{errors.RackCode}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Rack Lane <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.RackLane}
                                            onChange={(e) => handleChange('RackLane', e.target.value)}
                                        />
                                    </div>
                                    {errors.RackLane && <div className="text-danger">{errors.RackLane}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Sequence <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Sequence}
                                            onChange={(e) => handleChange('Sequence', e.target.value)}
                                        />
                                    </div>
                                    {errors.Sequence && <div className="text-danger">{errors.Sequence}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Weight <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={binData.Weight}
                                            onChange={(e) => handleChange('Weight', e.target.value)}
                                        />
                                    </div>
                                    {errors.Weight && <div className="text-danger">{errors.Weight}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Weight UOM <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={weightUomDropdownData}
                                            placeholder="Select"
                                            value={binData.WeightUOMID}
                                            onChange={(value) => handleChange('WeightUOMID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.WeightUOMID && <div className="text-danger">{errors.WeightUOMID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {binID && <Col md={4}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            placeholder="Select"
                                            value={binData.StatusID}
                                            onChange={(value) => handleChange('StatusID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddBinMasterData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddBinMaster;
